import { useTranslation } from 'react-i18next';
import { Fragment, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from 'entities/Auth';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/20/solid';
import _ from 'lodash';
import { AFRICA_SAFARI_LIGHT_LOGOS, TANZANIA_SPECIALIST_LIGHT_LOGOS } from 'utils/constants';
import NavigationLink from './NavigationLink';
import LanguageSelector from 'components/LanguageSelector';
import MobileNavigation from 'components/MobileNavigation';
import { URLS } from 'config/urls';
import { FlightTakeoffIcon } from '@/assets/icons/FlightTakeoffIcon';

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const tanzaniaSpecialistLightLogo = useMemo(() => {
    return _.get(TANZANIA_SPECIALIST_LIGHT_LOGOS, i18n.language);
  }, [i18n.language]);

  const africaSafariLightLogo = useMemo(() => {
    return _.get(AFRICA_SAFARI_LIGHT_LOGOS, i18n.language);
  }, [i18n.language]);

  const handleLogout = useCallback(async () => {
    try {
      await logout();
      navigate(URLS.LOGIN);
    } catch (error) {
      // TODO: Show error to the user
      console.error('Failed to logout', error);
    }
  }, [logout, navigate]);

  return (
    <Fragment>
      <div className={`w-full h-[var(--navigation-height)] bg-brand-brown flex justify-center`}>
        <div className='max-w-[1440px] w-full content-center px-[24px]'>
          <div className='flex align-center justify-between'>
            <div className='flex gap-[30px] h-[40px]'>
              <img src={tanzaniaSpecialistLightLogo} alt='Tanzania Specialist Logo' />
              <img src={africaSafariLightLogo} alt='Africa Safari Logo' />
            </div>
            <div className='flex gap-[24px] items-center max-md:hidden'>
              <NavigationLink className='group hover:bg-muted p-3 rounded-md flex flex-row gap-2' href={URLS.FLIGHTS}>
                <FlightTakeoffIcon className='h-6 w-6 text-white group-hover:text-brand-brown' />
                {t('navigation.flights')}
              </NavigationLink>
              <button
                onClick={handleLogout}
                className='group flex flex-row gap-2 text-white font-[MuseoSans900] uppercase tracking-[1.5px] cursor-pointer hover:bg-muted hover:text-brand-brown p-3 rounded-md'
              >
                <ArrowRightStartOnRectangleIcon className='h-6 w-6 text-white group-hover:fill-brand-brown' />
                {t('navigation.logout')}
              </button>
              <LanguageSelector hoverStyle='hover:bg-muted p-3 rounded-md' />
            </div>
          </div>
        </div>
      </div>
      <MobileNavigation
        openIcon={<Bars3Icon className='h-6 w-6 text-gray-500' />}
        closeIcon={<XMarkIcon className='h-6 w-6 text-gray-700' />}
        handleLogout={handleLogout}
      />
    </Fragment>
  );
};

export default Navigation;
